import { SiteAuthorizations } from "shared/api/api";


export const LOAD = 'LOAD';

export interface AuthorizationsState {
    auth: SiteAuthorizations;
}
